import React from 'react';
import PropTypes from 'prop-types';
import isObject from 'lodash/isObject';
import renderIf from '@signal/utils/renderIf';
import { Wrapper, TitleSkeleton, TitleLine, SubtitleSkeleton, DescriptionSkeleton } from './styles';
export default function ContentSectionHeadingSkeleton(_ref) {
  var title = _ref.title,
      subtitle = _ref.subtitle,
      description = _ref.description,
      RightContent = _ref.rightContent,
      className = _ref.className,
      style = _ref.style;
  var SubtitleComponent = isObject(subtitle) ? subtitle : /*#__PURE__*/React.createElement(SubtitleSkeleton, null);
  var RightContentComponent = /*#__PURE__*/React.isValidElement(RightContent) ? RightContent : function () {
    return /*#__PURE__*/React.createElement(RightContent, null);
  };
  return /*#__PURE__*/React.createElement(Wrapper, {
    className: className,
    style: style
  }, renderIf(subtitle, SubtitleComponent), /*#__PURE__*/React.createElement(TitleLine, null, renderIf(title, function () {
    return /*#__PURE__*/React.createElement(TitleSkeleton, null);
  }), renderIf(RightContent, RightContentComponent)), renderIf(description, function () {
    return /*#__PURE__*/React.createElement(DescriptionSkeleton, null);
  }));
}
ContentSectionHeadingSkeleton.propTypes = {
  title: PropTypes.bool,
  subtitle: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
  description: PropTypes.bool,
  rightContent: PropTypes.oneOfType([PropTypes.func, PropTypes.node])
};
ContentSectionHeadingSkeleton.defaultProps = {
  title: true,
  subtitle: true,
  description: true
};